"use client"

import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import '@/app/style/PDFFullScreen.scss';

const PDFBtn=styled(Button)`
    background-color: #212121;
    border-radius: 0;
    height: 24px;
    min-width:24px;
    width:24px;
    box-shadow:none!important;
    :hover{
        background-color: #212121;
    }
    :focus{
        boxShadow: 0 0 0 0.2rem rgba(0,123,255,.5)
    }
`

export default function PDFFullScreen(props:any){
    const [showFullScreen,setShowFullScreen]=useState(true)
    let shouldBeUpdate=true

    const handleFullScreen=()=>{
        setShowFullScreen(false)
        if(props.onClose){
            props.onClose()
        }
    }

    // function componentWillUnmount(){
    //     setShowFullScreen(true)
    // }

    return (
        <>
            {showFullScreen&&<div className="PDFFullScreen">
                <div className="PDFCloseFullScreenBtn">
                    <PDFBtn variant="contained" size="small" onClick={()=>{handleFullScreen()}}>
                        <CloseOutlinedIcon />
                    </PDFBtn>   
                </div>
                {props.children}
            </div>}
        </>
    )
}